import type { ReportDetails } from "@memorang/types";
import type { DemoExamsType } from "../demo";
import { mockedReport } from "./common";
import { mockedTags } from "./demo-mocked-mixeditemdist-response";

export const mockedReportResponse = (demoExamId: string) =>
	({
		id: 2336,
		numQuestions: mockedReport.cards.numTotalItems,
		numCorrect: 0,
		numIncorrect: 0,
		numSkipped: 0,
		markedCount: 0,
		numChoicePoints: null,
		totalChoicePoints: null,
		numPointsEarned: mockedReport.cards.numPointsEarned,
		numTotalPoints: mockedReport.cards.numTotalPoints,
		distribution: mockedReport.cards.distribution,
		tagDetails: mockedTags[demoExamId as DemoExamsType],
		accuracy: "28.00",
		sessionTime: 26,
		startTime: "2025-02-20T07:51:33.738Z",
		numericId: 2336,
		sessionType: "SUMMATIVE",
		numHints: 0,
		questionsAccuracy: null,
		answered: mockedReport.cards.numTotalAnswered,
		avgSpeed: 4.33,
		score: "80.00",
		sessionDate: "2025-02-20T07:51:33.738Z",
		reportSessionType: "SUMMATIVE",
		timeElapsed: 26,
	}) as unknown as ReportDetails;
